import React, { Component } from "react";
import { connect } from "react-redux";
import PopupHelp from "components/popups/popupHelp";
import {
    isMobile,
    rootUrl,
    appUrl,
    EXPERTS_ROUTES,
} from "helpers/ApplicationHelper";
import I18n from "lib/i18n/i18n";
import PopupFaq from "./popups/popupFaq";
import { chatBotSaveLog, chatBotJBSaveLog } from "actions/item";
import Hamburger from "./hamburger";
import { browserHistory } from "react-router";
import UserActions from "lib/userActions";
import MenuBar from "./menuBar";
import ExpertsHeader from "./experts/expertsHeader";
import { MediumPrimaryButton } from "@worthy-npm/clarity";
import { imageUrl, p13nServiceDecisions } from "../helpers/ApplicationHelper";
import { PromotionBannerHeight } from "./banners/promotionBanner";

const HAMBURGER_MENU_ROUTES = [
    "homepage",  //outdated for condition, placed on other service
    "how-it-works", //outdated for condition, placed on other service
    "selling-with-trust",
];

const MENU_ROUTES = [
    "homepage",  //outdated for condition, placed on other service
    "how-it-works", //outdated for condition, placed on other service
    "selling-with-trust"
];

import Item from "./item";
const ITEM_COMPONENT = Item; // In order to avoid name collision with Redux store's Item

class Header extends Component {
    constructor(props) {
        super(props);

        this.state = {
            menuVisible: false,
            prevScrollpos: typeof window !== `undefined` && window.pageYOffset,
            showPromotionBanner: false,
        };
        this.isMobile = isMobile();
        this.isDesktop = !this.isMobile;
    }

    componentDidUpdate() {
        const {
            isJewelryBox,
            itemId,
            cuiVersion,
            JBcuiVersion,
            isStandardCui,
        } = this.props;

        const displayFaq = isStandardCui || isJewelryBox;

        if (itemId && cuiVersion && displayFaq) {
            if (isJewelryBox) {
                chatBotJBSaveLog(
                    itemId,
                    this.logProps("presented", isJewelryBox),
                    JBcuiVersion
                );
            } else {
                chatBotSaveLog(itemId, this.logProps("presented"), cuiVersion);
            }
        }
    }

    componentWillUnmount() {
        document.getElementById("content").removeAttribute("style");
    }

    _onHelp = () => {
        if (this.props.workingHour) {
            window.location = `tel:${I18n.getString(this.props.highValue ? "common::vipPhoneNumber" : "common::phoneNumber")}`;
        } else {
            PopupHelp.initPopup({ single: true, modal: true });
        }
    };

    _openFaqs() {
        const {
            isJewelryBox,
            itemId,
            cuiVersion,
            JBcuiVersion,
            isFAQinJBCUIExperiment,
        } = this.props;

        PopupFaq.initPopup({
            popupClassName: `popup-faq ${isFAQinJBCUIExperiment && isJewelryBox ? "popup-faq-jb" : ""}`,
            isJB: isJewelryBox,
            isJBCuiExperiment: isFAQinJBCUIExperiment,
        });

        if (isJewelryBox) {
            // FAQ_JB_button_clicked
            chatBotJBSaveLog(
                itemId,
                this.logProps("clicked", isJewelryBox),
                JBcuiVersion
            );
        } else {
            chatBotSaveLog(itemId, this.logProps("clicked"), cuiVersion);
        }
    }

    logProps(action, isJewelryBox) {
        return {
            key: `${isJewelryBox ? "jb_" : ""}cui_faq_btn_${action}`,
            version: isJewelryBox
                ? this.props.JBcuiVersion
                : this.props.cuiVersion,
            item_id: this.props.itemId,
            type: "faq_button",
            direction: "0",
            text: `${isJewelryBox ? "JB-" : ""}CUI-FAQ button ${action}`,
        };
    }

    displayHamburger() {
        return (
            HAMBURGER_MENU_ROUTES.some((route) => this.props.path.includes(route))
            || this.experts
        );
    }

    isExperts() {
        return EXPERTS_ROUTES.some((route) => this.props.path.includes(route));
    }

    displayMenu() {
        return (
            this.isDesktop &&
            MENU_ROUTES.some((route) => this.props.path.includes(route))
        );
    }

    seeMyItems() {
        try {
            UserActions.drawerClick();
        } finally {
            window.location = appUrl(`/items`);
        }
    }

    sellingBtn() {
        return (
            <div className={"wrapper"}>
                {this.isDesktop ? (
                    <MediumPrimaryButton
                        text={I18n.getString("header::sellBtn::desktop")}
                        disabled={false}
                        click={() => (window.location = appUrl())}
                    />
                ) : (
                    <span
                        className={"selling-btn"}
                        onClick={() => {window.location = appUrl();}}
                    >
                        {I18n.getString(`header::sellBtn::mobile`)}
                    </span>
                )}
            </div>
        );
    }

    componentDidMount() {
        this.experts = this.isExperts();
        this.hamburger = this.displayHamburger();
    }

    isTrustSelling(){
      return this.props.path.includes("selling-with-trust")
    }

    freshHeader() {
        const { itemsCount } = this.props;
        const isLoggedIn = this.props.Session && this.props.Session.isLoggedIn;

        return <div className='header-v4'>
            <div className='logo-link-v4'>
                <a href={rootUrl()}
                    onClick={(e) => {
                        if (this.experts) {
                            e.preventDefault()
                            browserHistory.push("/learn")
                        } else {
                            e.preventDefault()
                            window.location.href = rootUrl();
                        }
                   }}
                >
                    <img src={imageUrl(`worthyLogoBlack.svg`)} alt="worthy-logo"></img>
                </a>
            </div>

            <div className='mobile-menu-v4' >
                { this.isTrustSelling() &&
                  <a className="link-to-phone" href="#" onClick={this._onHelp} >
                    <img alt="Worthy.com" src={imageUrl('phone.svg')} />
                  </a>
                }

                { isLoggedIn &&
                  <a className="link-to-items" href="#" onClick={() => this.seeMyItems()}>
                    <img alt="Worthy.com" src={imageUrl(`icons/user-icon.svg`)} />
                    <div className="user-profile-circe">{itemsCount > 9 ? '9+' : itemsCount}</div>
                  </a>
                }

                <Hamburger path={this.props.path} />
            </div>
        </div>
    }

    render() {
        const {
            sticky,
            highValue,
            footerVisible,
            isStandardCui,
            isJewelryBox,
            isHighValueCui,
            isUploadPhotoPage,
        } = this.props;

        const { menuVisible } = this.state;

        if (
            (this.displayMenu() || (this.experts && !this.isMobile)) &&
            typeof window !== "undefined"
        ) {
            // todo: why is this padding-top needed?
            document
                .getElementById("content")
                .style.setProperty("padding-top", "0");
        }

        // Real Desktop header !!!!
        if (!this.isMobile && this.experts) {
            return <ExpertsHeader />;
        }

        if(this.isMobile && (this.experts || this.isTrustSelling())) {
          return this.freshHeader()
        }

        const isLoggedIn = this.props.Session && this.props.Session.isLoggedIn;
        const displayFaq = isStandardCui || isJewelryBox || isHighValueCui;
        const headerClass = `${menuVisible ? "menu-visible " : ""} ${sticky || displayFaq ? "" : "not-sticky "}`;
        const mobileHelpBtnClass = `help-button mobile ${footerVisible ? "non-visible " : ""} ${this.hamburger ? "" : "left"}  `;

        const telephoneNumber = I18n.getString(
            highValue
                ? "common::vipPhoneNumberString"
                : "common::phoneNumberString"
        );
        const faqButtonClass = `
            ${ displayFaq ? "faqs-button " : "opacity-0 "}
            ${ isJewelryBox || highValue ? "faqs-button faqs-button_jb-test " : null}
        `;

        const displayDrawer = isLoggedIn && (isUploadPhotoPage || (!displayFaq && !this.displayMenu()));

        const itemsCount = this.props.itemsCount;
        const itemsIndicator = (
            <div className="blueCircle" onClick={() => this.seeMyItems()}>
                {itemsCount < 1 ? "" : itemsCount < 9 ? itemsCount : 9}
                {itemsCount > 9 && <span className="plus">+</span>}
            </div>
        );

        const faq = (
            <div className={"wrapper"}>
                <span
                    className={faqButtonClass}
                    onClick={this._openFaqs.bind(this)}
                >
                    {I18n.getString("header::faqs::name")}
                </span>
            </div>
        );

        const rightElement = displayDrawer ? (
            itemsIndicator
        ) : this.displayMenu() && !isLoggedIn ? (
            this.sellingBtn()
        ) : displayFaq ? (
            faq
        ) : this.hamburger && this.isMobile && !this.experts ? (
            <a className={mobileHelpBtnClass} onClick={this._onHelp} />
        ) : (
            <div className={"headerNotLoggedIn wrapper"}></div>
        );

        const style = {
            top: this.props.showBanner ? PromotionBannerHeight : "0",
        };

        return (
            <header className={headerClass}>
                <div className={`header ${this.displayMenu() ? "site-style" : null}`} style={style}>

                    {this.isMobile && this.hamburger ? (
                        <Hamburger path={this.props.path} />
                    ) : this.isMobile && !isLoggedIn ? (
                        <div className={"headerNotLoggedIn wrapper"}></div>
                    ) : null}

                    {this.isMobile && isLoggedIn ? (
                        <div className={"headerNotLoggedIn wrapper"}></div>
                    ) : (
                        <a
                            className={`help-button desktop ${!isLoggedIn && "flex-1"}`}
                            onClick={this._onHelp}
                            dangerouslySetInnerHTML={{
                                __html: telephoneNumber,
                            }}
                        />
                    )}

                    <a href={rootUrl()}
                        onClick={(e) => {
                            if (this.experts) {
                                e.preventDefault()
                                browserHistory.push("/learn")
                            } else {
                                e.preventDefault()
                                window.location.href = rootUrl();
                            }
                       }}
                    >
                        <img
                            src={imageUrl(`worthyLogoBlack.svg`)}
                            alt="worthy-logo"
                            className="logo-offset"
                        ></img>
                    </a>

                    {rightElement}
                </div>

                {this.displayMenu() ? <MenuBar /> : null}
            </header>
        );
    }
}

const mapStateToProps = (
    {
        ADO,
        Header,
        Footer,
        ChatBot,
        Experiments,
        Item,
        PendingJewelryBox,
        Session,
        CuiVersion,
        Personalized,
        UserFlow,
        ItemsCount,
    },
    { path }
) => {
    let isUploadPhotoPage;
    if (Item && ADO && Personalized) {
        const itemAnalyze = ITEM_COMPONENT.analyzeItemState(
            Item,
            ADO,
            Personalized,
            {
                submittedPhoto: !!(Item.photos && Item.photos.length),
            },
            UserFlow
        );
        isUploadPhotoPage = itemAnalyze["uploadPhoto"];
    }
    return {
        Session: Session,
        Experiments: Experiments,
        workingHour: ADO && ADO.working_hour,
        sticky: Header.sticky,
        footerVisible: Footer.showFooter,
        highValue: Item && Item.high_value_estimation,
        itemId:
            (Item && Item.id) || (PendingJewelryBox && PendingJewelryBox.id),
        isStandardCui: Personalized.preShipmentUi === p13nServiceDecisions.cui,
        JBcuiVersion:
            ChatBot.conversationFlow.jewelryBox[
                Experiments &&
                Experiments.jb_cui &&
                Experiments.jb_cui.status &&
                Experiments.jb_cui.variant === "true"
                    ? 1
                    : 0
            ][0].version,
        isJewelryBox: !!PendingJewelryBox,
        cuiVersion: CuiVersion,
        isHighValueCui:
            Personalized.preShipmentUi === p13nServiceDecisions.hvCui,
        isUploadPhotoPage,
        itemsCount: ItemsCount,
    };
};

export default connect(mapStateToProps)(Header);
